import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import * as z from "zod";

import { useState } from "react";
import { handleApiError } from "@/utils/errors";
import { catchError } from "@/lib/errors";
import { toast } from "sonner";
import { generatePassword } from "@/lib/utils";
import DotPattern from "@/components/dot-pattern";
import UserForm from "@/features/users/components/form/user-form";
import { userFormSchema } from "@/features/users/components/form/schemas";
import { usersRepo } from "@/lib/repositories";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@/constants/routes";
import { useTranslation } from "react-i18next";
import { queryClient } from "@/lib/query-client";

const UsersCreatePage = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const form = useForm<z.infer<typeof userFormSchema>>({
    resolver: zodResolver(userFormSchema),
    defaultValues: {
      username: "",
      first_name: "",
      last_name: "",
      password: generatePassword(),
    },
  });

  async function onSubmit(data: z.infer<typeof userFormSchema>) {
    setIsLoading(true);
    const [error, userData] = await catchError(usersRepo.create(data));
    if (error) toast.error(handleApiError(error).message);
    if (userData) {
      await queryClient.invalidateQueries({ queryKey: ["users"] });
      toast.success(t("messages.user_create_success"));
      form.reset();
      navigate(ROUTES.USERS);
    }
    setIsLoading(false);
  }

  return (
    <div className="relative h-full flex flex-col items-center gap-y-3 p-3 py-4 sm:py-10 sm:p-6">
      <DotPattern />
      <UserForm form={form} onSubmit={onSubmit} isLoading={isLoading} />
    </div>
  );
};

export default UsersCreatePage;
